/**
 * @generated SignedSource<<58fa7ee148638e2455fe5baecd93fcf4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type VatReportModal_seller$data = {
  readonly vatConfiguration: {
    readonly priceBookName: string | null;
  } | null;
  readonly " $fragmentType": "VatReportModal_seller";
};
export type VatReportModal_seller$key = {
  readonly " $data"?: VatReportModal_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"VatReportModal_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "VatReportModal_seller",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "VatConfiguration",
      "kind": "LinkedField",
      "name": "vatConfiguration",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "priceBookName",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "7563e0fea109d6e7031562d65ffc7793";

export default node;
